module.exports = __webpack_public_path__ + "img/sv58.7bf511bd.svg";